module.exports = __webpack_public_path__ + "static/media/city-tour.cc4fcf6f.png";